import createAxiosInstance from "../../utils/axiosConfig";
import { getUseCaseName } from "../../utils/constants";
import { get_top_items } from "../../utils/endpoints";
import { TopicSuggestionProps, TopItemsResponse, TrendingQuestion } from "../../utils/interfaces";
import { useEffect, useState } from "react";

const TopicSuggestionCards = ({ selectUseCase, setSelectSubCase, chatId, handleOptionSelect, startChat }: TopicSuggestionProps) => {
	const [topItems, setTopItems] = useState<TopItemsResponse>();
	const [loading, setLoading] = useState<boolean>(true);
	
	const getTopItems = async ()=>{
		setLoading(true);
		try{
			const axiosInstance = createAxiosInstance();
			const response = await axiosInstance.get(get_top_items);
			setTopItems(response.data);
			console.log(response);
			
		} catch (error) {
			console.log(error);
			setLoading(false);
		}finally{
			setLoading(false);
		}
	}

	useEffect(()=>{
		getTopItems();
	}, []);

	const getRandomUseCase = () => {
		const useCaseValues = [1, 3, 7];
		const randomIndex = Math.floor(Math.random() * useCaseValues.length);
		return useCaseValues[randomIndex];
	};

	const SkeletonCard = () => (
		<div className="col">
			<div className="card h-100 d-flex flex-column">
				<div className="card-body d-flex flex-column">
					<div className="d-flex flex-column justify-content-center flex-grow-1">
						<div className="skeleton mb-3" style={{ height: "24px", width: "70%", backgroundColor: "#e0e0e0" }}></div>
					</div>
					<div className="d-flex flex-column justify-content-end flex-grow-1">
						<div className="skeleton" style={{ height: "16px", width: "100%", backgroundColor: "#e0e0e0" }}></div>
						<div className="skeleton mt-2" style={{ height: "16px", width: "80%", backgroundColor: "#e0e0e0" }}></div>
					</div>
				</div>
			</div>
		</div>
	);

	return (
		<div className="row g-4">
			{loading ? (
				<>
					<SkeletonCard />
					<SkeletonCard />
					<SkeletonCard />
					<SkeletonCard />
					<SkeletonCard />
				</>
			) : (
				topItems?.topics?.slice(0, 5).map((item: TrendingQuestion, key) => (
					<div className="col" key={`case_cards_${key}`}>
						<div
							className="card h-100 d-flex flex-column"
							onClick={() => {
								selectUseCase(item.label.includes("3") ? Number(item.label.split("_")[2].split(".")[0]) : Number(item.label.split("_")[2]), item?.trending_questions?.[0]);
								console.log(item.label.includes("3"), "includes 3");
                                if(item.label.includes("3")){
									
									// setSelectSubCase(item.label.split("_")[2].split(".")[1]);
									// console.log(`I know exactly what I want`, chatId, 'b')
                                    console.log(item.label.split("_")[2].split(".")[0], "split  ", chatId)
                                    startChat(Number(item.label.split("_")[2].split(".")[0]), 'b');
									// handleOptionSelect(`I know exactly what I want`, chatId, 'b');
								}
							}}
							style={{ cursor: "pointer" }}
						>
							<div className="card-body d-flex flex-column">
								
								<div className="d-flex flex-column justify-content-start flex-grow-1">
									<span className="card-text text-secondary">
										{item?.trending_questions?.[0]}
									</span>
								</div>
                                {/* <span className="text-blue mt-0">{getUseCaseName(item.label)}</span> */}
							</div>
						</div>
					</div>
				))
			)}
		</div>
	);
};

export default TopicSuggestionCards;
